/**
 * Decide what an unavailable legacy PDP should do while resolving a parent
 * section for treatment chrome.
 *
 * `wait` — main menu still loading; keep the skeleton.
 * `navigate` — parent section known; redirect into section pin/recovery.
 * `fallback` — main menu settled with no resolvable section (empty/failed
 * load or item absent); show MenuItemUnavailable + recovery CTA instead of
 * spinning forever.
 */
export function resolveLegacyUnavailableSectionRedirect({
  mainMenuSettled,
  sectionIdForUnavailable,
}: {
  mainMenuSettled: boolean;
  sectionIdForUnavailable?: string;
}): 'wait' | 'navigate' | 'fallback' {
  if (sectionIdForUnavailable) {
    return 'navigate';
  }

  if (!mainMenuSettled) {
    return 'wait';
  }

  return 'fallback';
}
